// cookie settings
export const gtmId = '#{group.gtm.id}';

export const gtmEnable = '#{group.gtm.enabled}';

